import { cn } from '../cn.ts';

export interface SpinnerProps {
  /** Pixel size. Default 20. */
  size?: number;
  className?: string;
  /** Accessible label; omit when the spinner sits inside something that already says "loading". */
  label?: string;
}

export function Spinner({ size = 20, className, label }: SpinnerProps) {
  return (
    <svg
      className={cn('animate-spin text-current shrink-0', className)}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      role={label ? 'status' : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
    >
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeOpacity="0.2" strokeWidth="3" />
      <path d="M21 12a9 9 0 0 0-9-9" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
    </svg>
  );
}
